// @flow
import { createAction } from 'redux-actions';
import { getService } from 'constants/ajax';
import xws from 'api/xws/';
import type { Dispatch } from 'types/redux';
import type { State as StoreState } from 'store/State';

// Action Types
import { SET_STATUS_TRACKER_DATA } from './actionTypes';

// Actions
import { ajaxCallbacks } from 'store/reducers/ajaxCall/actions';

// Selectors
import { getWebkey } from 'store/reducers/queryParams/selectors';
import { getPersonId } from 'store/reducers/user/personInfo/selectors';

export const setStatusTracker = createAction(SET_STATUS_TRACKER_DATA);

export const updateNotificationPreference = (
  notificationType: String,
  action: Boolean
) => async (dispatch: Dispatch, getState: () => StoreState) => {
  const saveApptStatusChange = getService('statusChangePreference');
  const personId = getPersonId(getState());
  const webKey = getWebkey(getState());
  try {
    saveApptStatusChange.setPathVars({
      personId,
      webKey,
      notificationType,
      action: action ? 'enable' : 'disable'
    });
    saveApptStatusChange.setCallBacks(dispatch(ajaxCallbacks()));
    await xws(saveApptStatusChange).post(saveApptStatusChange.getPath());
    return true;
  } catch (err) {
    /* eslint-disable no-console */
    console.error(err);
    /* eslint-disable no-console */
  }
  return false;
};

export const setStatusTrackerData = (statusTrackerData: Object) => {
  return {
    type: SET_STATUS_TRACKER_DATA,
    payload: statusTrackerData
  };
};



// WEBPACK FOOTER //
// ./src/store/reducers/statusTracker/actions.js